// src/pages/Education.jsx
import React from "react";
import { Link } from "react-router-dom";
import { useData } from "../context/DataProvider";

const Education = () => {
   const { articles, loading } = useData();

   if (loading) {
      return <div className="p-8">Жүктелуде...</div>;
   }

   // Фильтруем статьи, где CategoryID = "5" (Білім)
   const educationArticles = articles.filter((article) => article.CategoryID === "5");

   return (
      <div>
         {/* Шапка (Hero) */}
         <header className="relative bg-gray-900 text-white py-12 px-4 sm:px-6 lg:px-8 mb-8">
            <div
               className="absolute inset-0 bg-cover bg-center"
               style={{
                  backgroundImage:
                     "url('https://images.unsplash.com/photo-1630448931928-f9a3d46a6dae?ixlib=rb-4.0.3&auto=format&fit=crop&w=1400&q=60')",
               }}
            />
            <div className="relative max-w-5xl mx-auto">
               <h1 className="text-4xl sm:text-5xl font-bold mb-2">Білім</h1>
               <p className="text-lg text-gray-200 max-w-2xl">
                  Мектеп пен жоғары оқу орындарынан бастап қосымша білім беру мен инновациялық оқыту әдістеріне дейінгі ақпаратты
                  осы жерден табуға болады.
               </p>
            </div>
         </header>

         {/* Негізгі контент */}
         <main className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
            <section className="mb-8">
               <h2 className="text-2xl font-bold mb-4">Қош келдіңіздер!</h2>
               <p className="mb-4">
                  Бұл бөлімде сіздер білім беру саласындағы соңғы жаңалықтар мен маңызды өзгерістер жайлы ақпараттармен таныса
                  аласыздар. Мектеп, колледж, университет және қосымша білім орталықтарының қызметтері, инновациялық технологиялар
                  мен әдістемелер – бәрі де назарымызда.
               </p>
               <p>
                  Ұстаздар мен оқушылардың жетістіктері, білім беру гранттары мен халықаралық бағдарламалар туралы деректерді де
                  осы жерден табасыздар. Елдің болашағы – сапалы білім мен білікті мамандардың қалыптасуында. Білім жолында бізбен
                  бірге болыңыз!
               </p>
            </section>

            {/* Карточки (ID=5) */}
            <section>
               <h2 className="text-xl font-bold mb-4">Білім жаңалықтары</h2>
               {educationArticles.length === 0 ? (
                  <p>Білім санатында жаңалықтар жоқ</p>
               ) : (
                  <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
                     {educationArticles.map((article) => (
                        <EducationCard key={article.ID} article={article} />
                     ))}
                  </div>
               )}
            </section>
         </main>
      </div>
   );
};

/* Карточка отдельной новости */
function EducationCard({ article }) {
   const { ID, Title, Category, Date, ImageUrl } = article;

   return (
      <article className="bg-white rounded-lg shadow-sm hover:shadow-md transition-shadow">
         <img
            src={ImageUrl || "https://via.placeholder.com/400x300"}
            alt={Title}
            className="w-full h-48 object-cover rounded-t-lg"
         />
         <div className="p-4">
            <p className="text-xs text-gray-500 mb-1">
               {Category} &mdash; {Date}
            </p>
            <h3 className="text-base font-semibold text-gray-800 mb-2 line-clamp-2">{Title}</h3>
            <Link to={`/news/${ID}`} className="text-sm text-blue-600 hover:underline">
               Толықтай оқу
            </Link>
         </div>
      </article>
   );
}

export default Education;
